import { __assign, __rest } from "tslib";
import React from 'react';
import { componentMap } from '../../form-component-map/index';
import { CnFilterPro as CnFilterUI, CnFilterProItem as CnFilterItemUI, CnSearch, } from '@cainiaofe/cn-ui';
var CnFilterPro = function (props) {
    var componentsProps = props.components, _a = props.onecodeProps, onecodeProps = _a === void 0 ? {} : _a, restProps = __rest(props, ["components", "onecodeProps"]);
    var components = __assign(__assign({ CnSearch: CnSearch }, componentMap), componentsProps);
    // 将移动端右侧插槽映射到PC的extendButtons插槽，如果存在rightSlot
    var hasRightSlot = !!(restProps === null || restProps === void 0 ? void 0 : restProps.rightSlot);
    if (hasRightSlot) {
        restProps.extendButtons = restProps.rightSlot;
    }
    return (React.createElement(CnFilterUI, __assign({ components: components }, restProps, onecodeProps)));
};
var CnFilterProItem = function (props) {
    var title = props.title;
    return React.createElement(CnFilterItemUI, __assign({ label: title }, props));
};
export { CnFilterPro, CnFilterPro as CnFilter, CnFilterProItem as CnFilterItem, CnFilterProItem, };
